import React, { FC } from 'react'
import { Flex, breakpoints, Text, Button } from '@components/gassan-ui'
import shoppingBag from './assets/bg_shopping_bag.svg'
import styled from 'styled-components'
import { useLocalization } from '@components/Localization'
import LocalizedLink from '@components/Localization/LocalizedLink'

const Image = styled.img`
  height: auto;
  width: 8rem;
  margin-bottom: 2rem;

  @media screen and (min-width: ${breakpoints.medium}) {
    width: 10rem;
  }

  @media screen and (min-width: ${breakpoints.large}) {
    width: 12rem;
    margin-bottom: 2.5rem;
  }
`

const EmptyCart: FC = () => {
  const { lang } = useLocalization()
  return (
    <Flex
      py={{ _: '3rem', large: '2.5rem 8.75rem' }}
      justifyContent="center"
      flexDirection="column"
      alignItems="center"
    >
      <Image src={shoppingBag} alt="empty shopping bag" />
      <Text variant="large" mb={{ _: '2rem', large: '3rem' }}>
        {lang === 'nl'
          ? 'U heeft geen artikelen in uw winkelwagen.'
          : 'You have no items in your shopping cart.'}
      </Text>
      <LocalizedLink href="/" as="">
        <Button variant="dark">{lang === 'nl' ? 'Verder winkelen' : 'Continue shopping'}</Button>
      </LocalizedLink>
    </Flex>
  )
}

export default EmptyCart
